module.exports = __webpack_public_path__ + "img/pdi2.fb705878.svg";